import { Injectable } from '@angular/core';
import { CompanyActions, OccCompanyService } from '@company/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class SearchCompanyEffects {
  searchCompany$: Observable<CompanyActions.SearchCompanySuccess | CompanyActions.SearchCompanyFail> = createEffect(
    () =>
      this.actions$.pipe(
        ofType<CompanyActions.SearchCompany>(CompanyActions.SEARCH_COMPANY),
        switchMap((action) =>
          this.occCompanyService.searchCompany(action.payload).pipe(
            map((result) => new CompanyActions.SearchCompanySuccess(result)),
            catchError(() => of(new CompanyActions.SearchCompanyFail())),
          ),
        ),
      ),
  );

  constructor(
    private actions$: Actions,
    private occCompanyService: OccCompanyService,
  ) {}
}
